// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Carousel_carouselWrapper__BM4XY {
    width: 100%;
}

.Carousel_carouselHeader__o9Cr6 {
    color: var(--color-darkui-surface-1);
    display: flex;
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 22px;
    font-weight: 100;
    justify-content: space-between;
    padding: 5px 0 11px;
    text-rendering: optimizelegibility;
}

/* Unused, carouselContainer is to get a clean 100% size for the carouselTape CSS and ResizeObserver */
/* .carouselContainer { } */

.Carousel_carouselWindow__Mg-8\\+, .Carousel_carouselWindowOverflow__WvAKE {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    box-sizing: border-box;
}

.Carousel_carouselTape__aKq5l {
    position: relative;
    transition: all 0.5s;
    display: flex;
    flex-direction: row;
}

.Carousel_slide__Ly9z2 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    box-sizing: border-box;
    border: solid var(--color-lightui-surface-4);
    border-radius: 8px;
    box-shadow: 0px 4px 4px var(--color-lightui-surface-4);
}

.Carousel_innerSlide__He-Mt {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    height: 100%;
}

.Carousel_emptySlide__K3ecN {
    box-sizing: border-box;
    border: solid var(--color-lightui-surface-2);
    background-color: var(--color-lightui-surface-2);
    border-radius: 8px;
}


/* Controls */
.Carousel_controlIcon__Vnt\\+q {
    color: var(--color-darkui-surface-1);
}

.Carousel_controlButton__KiDdH {
    background-color: var(--color-lightui-surface-3);
    border-radius: 50%;
    height: 24px;
    width: 24px;
}

.Carousel_controlContainer__si5mM {
    display: flex;
    align-items: center;
}

.Carousel_leftControlButton__Af7Fc {
    margin-right: 5px;
}

.Carousel_controlIconInactive__RjifS {
    cursor: not-allowed;
    opacity: 0.5;
}


/* Dots */
.Carousel_carouselDotContainer__JlALl {
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 11px;
    padding-right: 5px;
}

.Carousel_carouselDotContainerHidden__Irjxv {
    visibility: hidden;
}

.Carousel_carouselDotContainerVisible__z-msq {
    visibility: visible;
}

.Carousel_carouselDots__6M4gM {
    background-color: var(--color-darkui-accent-2);
    border-radius: 50%;
    display: inline-block;
    height: 4px;
    margin-left: 5px;
    width: 4px;
}

.Carousel_carouselHighlightedDot__5VBC9 {
    background-color: black;
    height: 8px;
    width: 8px;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Carousel/Carousel.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,uHAAuH;IACvH,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA,sGAAsG;AACtG,2BAA2B;;AAE3B;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;;IAEhB,sBAAsB;IACtB,4CAA4C;IAC5C,kBAAkB;IAClB,sDAAsD;AAC1D;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,4CAA4C;IAC5C,gDAAgD;IAChD,kBAAkB;AACtB;;;AAGA,aAAa;AACb;IACI,oCAAoC;AACxC;;AAEA;IACI,gDAAgD;IAChD,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;;AAGA,SAAS;AACT;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,UAAU;AACd","sourcesContent":[".carouselWrapper {\n    width: 100%;\n}\n\n.carouselHeader {\n    color: var(--color-darkui-surface-1);\n    display: flex;\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-size: 22px;\n    font-weight: 100;\n    justify-content: space-between;\n    padding: 5px 0 11px;\n    text-rendering: optimizelegibility;\n}\n\n/* Unused, carouselContainer is to get a clean 100% size for the carouselTape CSS and ResizeObserver */\n/* .carouselContainer { } */\n\n.carouselWindow, .carouselWindowOverflow {\n    width: 100%;\n    height: 100%;\n    overflow-x: hidden;\n    box-sizing: border-box;\n}\n\n.carouselTape {\n    position: relative;\n    transition: all 0.5s;\n    display: flex;\n    flex-direction: row;\n}\n\n.slide {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n\n    box-sizing: border-box;\n    border: solid var(--color-lightui-surface-4);\n    border-radius: 8px;\n    box-shadow: 0px 4px 4px var(--color-lightui-surface-4);\n}\n\n.innerSlide {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n    width: 100%;\n    min-width: 100%;\n    max-width: 100%;\n    height: 100%;\n}\n\n.emptySlide {\n    box-sizing: border-box;\n    border: solid var(--color-lightui-surface-2);\n    background-color: var(--color-lightui-surface-2);\n    border-radius: 8px;\n}\n\n\n/* Controls */\n.controlIcon {\n    color: var(--color-darkui-surface-1);\n}\n\n.controlButton {\n    background-color: var(--color-lightui-surface-3);\n    border-radius: 50%;\n    height: 24px;\n    width: 24px;\n}\n\n.controlContainer {\n    display: flex;\n    align-items: center;\n}\n\n.leftControlButton {\n    margin-right: 5px;\n}\n\n.controlIconInactive {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\n\n/* Dots */\n.carouselDotContainer {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    margin: 11px;\n    padding-right: 5px;\n}\n\n.carouselDotContainerHidden {\n    visibility: hidden;\n}\n\n.carouselDotContainerVisible {\n    visibility: visible;\n}\n\n.carouselDots {\n    background-color: var(--color-darkui-accent-2);\n    border-radius: 50%;\n    display: inline-block;\n    height: 4px;\n    margin-left: 5px;\n    width: 4px;\n}\n\n.carouselHighlightedDot {\n    background-color: black;\n    height: 8px;\n    width: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carouselWrapper": `Carousel_carouselWrapper__BM4XY`,
	"carouselHeader": `Carousel_carouselHeader__o9Cr6`,
	"carouselWindow": `Carousel_carouselWindow__Mg-8+`,
	"carouselWindowOverflow": `Carousel_carouselWindowOverflow__WvAKE`,
	"carouselTape": `Carousel_carouselTape__aKq5l`,
	"slide": `Carousel_slide__Ly9z2`,
	"innerSlide": `Carousel_innerSlide__He-Mt`,
	"emptySlide": `Carousel_emptySlide__K3ecN`,
	"controlIcon": `Carousel_controlIcon__Vnt+q`,
	"controlButton": `Carousel_controlButton__KiDdH`,
	"controlContainer": `Carousel_controlContainer__si5mM`,
	"leftControlButton": `Carousel_leftControlButton__Af7Fc`,
	"controlIconInactive": `Carousel_controlIconInactive__RjifS`,
	"carouselDotContainer": `Carousel_carouselDotContainer__JlALl`,
	"carouselDotContainerHidden": `Carousel_carouselDotContainerHidden__Irjxv`,
	"carouselDotContainerVisible": `Carousel_carouselDotContainerVisible__z-msq`,
	"carouselDots": `Carousel_carouselDots__6M4gM`,
	"carouselHighlightedDot": `Carousel_carouselHighlightedDot__5VBC9`
};
export default ___CSS_LOADER_EXPORT___;
